export default "__VITE_ASSET__c4a87749__"